import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class InputMixin extends Vue {
    @Prop({default: '', required: true}) protected readonly id: string;
    @Prop({default: false}) protected readonly disabled: boolean | any;
    @Prop({default: false}) protected readonly readonly: boolean;
    @Prop({default: false}) protected readonly autofocus: boolean;
    @Prop({default: true}) protected readonly changeDetectable: boolean;
    @Prop({default: true}) protected readonly clearable: boolean;

    @Prop({default: undefined}) protected readonly maxLength: number;
    @Prop({default: null}) protected readonly value: any;
    @Prop({default: null}) protected readonly originValue: any;
    @Prop({default: ''}) protected readonly placeHolder: string;
    @Prop({default: ''}) protected readonly size: string;

    get getId() {
        return this.id;
    }

    get isDisabled() {
        return this.disabled;
    }

    get isReadOnly() {
        return this.readonly;
    }

    get supplyAutofocus() {
        return this.autofocus;
    }

    get isClearable() {
        return this.clearable;
    }

    get getMaxLength() {
        return this.maxLength;
    }

    get inputValue() {
        return this.value;
    }

    get getPlaceHolder() {
        return this.placeHolder;
    }

    get getSize() {
        return this.size;
    }

    /**
     * 아래와 같이 disabled 코드와 연달아 처리하는 경우
     * disabled 어트리뷰트가 해제된 상태에서 focus를 호출해야 하기에 임의의 시간을 딜레이 할 수 있게 함
     *
     * this.formDisabled = false;
     * const elment = this.$refs.element;
     * element.focus();
     */
    public focus(delay?: number) {
        let component: any = this.$refs.elementRef;
        if (component instanceof Array) {
            component = component[0];
        }

        if (delay) {
            setTimeout(() => {
                if (component && component.focus) {
                    component.focus();
                }
            }, 100);
        } else {
            if (component && component.focus) {
                component.focus();
            }
        }
    }

    public blur(delay?: number) {
        let component: any = this.$refs.elementRef;
        if (component instanceof Array) {
            component = component[0];
        }

        if (delay) {
            setTimeout(() => component.blur(), 100);
        } else {
            component.blur();
        }
    }

    protected onEnter($event: KeyboardEvent) {
        this.$emit('enter', $event);
    }

    protected onBlur($event: FocusEvent) {
        this.$emit('blur', $event);
    }

    protected onClear() {
        this.$emit('clear');
    }
}
